// removed by extract-text-webpack-plugin
module.exports = {"vpCodecSupportWarning":"vpCodecSupportWarning___2ew5i","vpCodecSupportWarningDismissButton":"vpCodecSupportWarningDismissButton___3lClt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/CodecWarning.module.less
// module id = 3512
// module chunks = 33